<button class="notice" [uiMenu]="notices" (click)="markAllNotificationsAsRead()">
    <svg-icon src="/assets/icons/notifications.svg"></svg-icon>
    <svg-icon *ngIf="hasUnreadNotifications" class="alert" src="/assets/icons/alert.svg"></svg-icon>
</button>
<ui-menu #notices class="notifications-menu">
    <ui-menu-item class="notification empty" *ngIf="!hasNotifications">
        <p class="caption">Notifications</p>
        <span class="body">There are no new notifications.</span>
    </ui-menu-item>
    <ui-menu-item class="notification" *ngFor="let notification of notifications">
        <notification [notification]="notification"></notification>
    </ui-menu-item>
</ui-menu>